export const SET_DICTINJURYTYPE = 'SET_DICTINJURYTYPE';
export const SET_DICTINJURYTYPES = 'SET_DICTINJURYTYPES';
export const SET_DICTINJURYTYPES_QUERY_PARAMS = 'SET_DICTINJURYTYPES_QUERY_PARAMS';
export const SET_DICTINJURYTYPES_SET_IS_FETCHING = 'SET_DICTINJURYTYPES_SET_IS_FETCHING';
